import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.css';

import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation, Pagination, A11y } from 'swiper';
import image2 from '../images/my certifie/freecodecamp-sertificat.jpeg';
import image3 from '../images/my certifie/front-end-certifie.png';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const MyTitle = () => {
    return (
        <>
            <div className="rank">
                <h1 className="rank-title">My rank</h1>
                <div className="my-rank">
                    <Swiper 
                        modules={[Navigation, Pagination, A11y]}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                    >
                        <div>
                            <SwiperSlide>
                                <img src={image2} alt="Sertificate" />
                            </SwiperSlide>
                        </div>
                        <div>
                            <SwiperSlide>
                                <img src={image3} alt="Sertificate" />
                            </SwiperSlide>
                        </div>
                    </Swiper>
                </div>
            </div>
        </>
    )
}

export default MyTitle